// How long before and after the scheduled start time the meeting can be joined
export const DEFAULT_JOIN_WINDOW_MINUTES = 5;

// Per-account overrides of the join window, keyed by account ID.
// Accounts not listed here use DEFAULT_JOIN_WINDOW_MINUTES.
// Example: { 1234: 30 } lets account 1234 join from 30 minutes before to 30 minutes after the start.
export const JOIN_WINDOW_MINUTES_BY_ACCOUNT: Record<number, number> = {
  233: 30,
};

export const getJoinWindowMs = (accountId?: number): number => {
  const minutes =
    (accountId !== undefined ? JOIN_WINDOW_MINUTES_BY_ACCOUNT[accountId] : undefined) ?? DEFAULT_JOIN_WINDOW_MINUTES;
  return minutes * 60 * 1000;
};
